// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hidden_header {\n    display: none;\n}\n#modal-title {\n    color: #af5934;\n    font-size: 15px;\n    font-weight: bold;\n}\n.container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.center {\n    padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
